import { withRouter } from 'react-router-dom';
import NoAccess from './NoAccess';

export default withRouter(NoAccess);
